document.addEventListener('DOMContentLoaded', function() {
  var faqShort = document.querySelector('.faq-short-container');
  if (!faqShort) return;
  faqShort.querySelectorAll('a[href^="#"]').forEach(function(link) {
    link.addEventListener('click', function(e) {
      var targetId = this.getAttribute('href').slice(1);
      var target = document.getElementById(targetId);
      if (target) {
        e.preventDefault();
        var headerOffset = 150; // Höhe des festen Headers ggf. anpassen!
        var elementPosition = target.getBoundingClientRect().top + window.pageYOffset;
        var offsetPosition = elementPosition - headerOffset;
        window.scrollTo({ top: offsetPosition, behavior: 'smooth' });
      }
    });
  });
});
